import dayjs from '@/dayjs'
import { createStore } from 'vuex'

export default createStore({
  state: {
    rail: false,
    alert: false,
    textAlert: '',
    typeAlert: 'warning',
    editProfile: false,
    addStation: false,
    addOperator: false,
    groupModal: false,
    editOperator: false,
    manageRequests: false,
    addShift: false,
    editShift: false,
    addWatcher: false,
    addResource: false,
    addIntegration: false,
    addLine: false,
    editLine: false,
    editStation: false,
    tabs: [],
    activeTab: null,
    rules: {
      companyRules: [(v) => !!v || 'Company name is required'],
      emailRules: [
        (v) => !!v || 'Email is required',
        (v) =>
          /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || 'Email must be valid',
      ],
      passwordRules: [
        (v) => !!v || 'Password is required',
        (v) => /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/.test(v) || 'Min 8 chars contain upper&lower case and number',
      ],
    },
    open: [],
    deactiveStation: false,
    deactiveOperation: false,
    terminationSetting: false,
    upgradeGain: false,
    createOperation: false,
    setStation: false,
    operationGraph: false,
    operation: {
      operation_name: '',
      graph: [],
      desire_quantity: 0,
      desire_duration: 'shift',
      line: null,
      shift: null,
      product: null,
      product_name: '',
      station: [],
      lines: [],
      start: null,
      stop: null,
      operator: [],
      image: null,
    },
    addProduct: false,
    stationsCoordinate: [],
    userInfo: {},
    factoryInfo: {},
    setting: 'plans',
    manualReport: false,
    manualStore: null,
    reportRequest: false,
    reportQuality: false,
    reportCounter: false,
    reportIssue: false,
    reportRework: false,
    screen: false,
    replySolution: false,
    scheduleVisit: false,
    chargeWallet: false,
    trackLink: false,
    gradeProduct: false,
    productSummary: false,
    reportCapture: false,
    reportProduct: false,
    addLevel: false,
    diffTime: 0,
    calculationFullscreen: false
  },
  getters: {},
  mutations: {
    railToggle(state) {
      state.rail = !state.rail
    },
    editProfileToggle(state) {
      state.editProfile = !state.editProfile
    },
    setCurrentTime(state, serverDate) {
      const diff = dayjs().diff(dayjs(serverDate), 'seconds')
      state.diffTime = Math.abs(diff) <= 2 ? 0 : diff
    },
  },
  actions: {},
  modules: {},
})
